import React, { Component } from 'react'
import { createStore, applyMiddleware } from 'redux'
import { Provider } from 'react-redux'
import thunkMiddleware from 'redux-thunk'
import { createLogger } from 'redux-logger'
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles'
import reducers from './reducers'

import Snackbar from './containers/Snackbar'
import Alert from './containers/Alert'
import Router from './Router'

import '../App.css'

const loggerMiddleware = createLogger()

class App extends Component {
  render() {
    const theme = createMuiTheme({
      fontFamily: 'Lato',
      overrides: {
        MuiInput: {
          underline: {
            '&:after': {
              borderBottom: '2px solid #289e64'
            }
          }
        }
      }
    })

    return (
      <Provider
        store={createStore(
          reducers,
          applyMiddleware(thunkMiddleware, loggerMiddleware)
        )}
      >
        <MuiThemeProvider theme={theme}>
          <Router />
          <Snackbar />
          <Alert />
        </MuiThemeProvider>
      </Provider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/components/App.js